import 'url-search-params-polyfill';

export const queryTypes = ['g', 'cr', 'cl', 'ed', 'ex', 's', 'c'];
export const queryTypeExplore = ['s', 'c'];

// Convert state values to string or an array
export const processKey = key => {
  if (typeof key == 'string') {
    return key;
  } else if (Array.isArray(key)) {
    if (!key.length > 0) return '';

    const list = key
      .reduce(
        (prev, curr) =>
          prev.concat(curr.hasOwnProperty('value') ? curr.value : ''),
        [],
      )
      .join(',');

    return list;
  } else {
    return key.value;
  }
};

// Create Object keys for Facet Query
export const createFacetObjects = (facets, type) => {
  let facetName = type == 'c' ? 'competencies' : 'setting';
  let list;

  if (typeof facets == 'string') {
    list = facets.split('+');
  } else {
    list = facets;
  }

  const output = list.reduce(
    (prev, curr, index) =>
      prev.concat({
        [facetName]: curr.hasOwnProperty('value') ? curr.value : curr,
      }),
    [],
  );

  return output;
};

const getfirstKeyValue = obj => {
  var output = [];

  for (const key in obj) {
    output.push(key);
    output.push(obj[key]);
  }
  return output;
};

export const serializeStateFacet = state => {
  const param = new URLSearchParams();
  let combinedParamArray = [];

  queryTypeExplore.forEach(key => {
    if (state[key] != undefined) {
      combinedParamArray = combinedParamArray.concat(
        ...createFacetObjects(state[key], key),
      );
    }
  });

  if (combinedParamArray.length > 0) {
    combinedParamArray.forEach((currparam, index) => {
      let paramKeyValue = getfirstKeyValue(currparam);
      param.set(`f[${index}]`, `${paramKeyValue[0]}:${paramKeyValue[1]}`);
    });
  }

  return param.toString();
};

export const serializeState = state => {
  const param = new URLSearchParams();
  queryTypes.forEach(key => {
    param.set(key, processKey(state[key]));
  });

  return param.toString();
};
